import { app } from '../../../../bootstrap/core';
import { selectState } from './select.state';
import { selectComponent } from './select.component';

app.config(selectState);
app.component(selectComponent.name, selectComponent);
